import "./app.css";
import { useAuth } from "@workos-inc/authkit-react";
import { V2Routes } from "./routes";
import { Toaster } from "./components/ui/toaster";
import { hasAnyAdminAccess } from "@/shared/config/adminPermissions";
import { ThemeProvider } from "@/shared/hooks/useTheme";

export function V2App() {
  const { user } = useAuth();
  const isAdmin = user ? hasAnyAdminAccess(user.email) : false;

  return (
    <ThemeProvider>
      <Toaster />
      <V2Routes isAdmin={isAdmin} />
    </ThemeProvider>
  );
}
